// NR · Night hero: deferred footage + desktop headlight.
// The poster is the LCP image; the video only starts once the page has loaded and the
// browser is idle, and never for reduced-motion or data-saver visitors.

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const isMobile = window.matchMedia('(max-width: 749px)');
const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

function slowConnection() {
  const c = navigator.connection;
  return Boolean(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
}

function whenIdle(fn) {
  const run = () => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 2500 }) : setTimeout(fn, 600));
  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run, { once: true });
}

function initHero(hero) {
  if (hero.dataset.nrReady) return;
  hero.dataset.nrReady = '1';

  const video = hero.querySelector('.nr-hero__video');
  const pauseBtn = hero.querySelector('[data-nr-hero-pause]');
  let userPaused = false;
  let inView = true;

  const setPausedUi = (paused) => {
    hero.classList.toggle('is-paused', paused);
    if (!pauseBtn) return;
    pauseBtn.querySelector('[data-label-pause]').hidden = paused;
    pauseBtn.querySelector('[data-label-play]').hidden = !paused;
  };

  // One control pauses everything that moves in the hero: footage, light trails, pulse
  pauseBtn?.addEventListener('click', () => {
    userPaused = !userPaused;
    setPausedUi(userPaused);
    if (!video) return;
    if (userPaused) video.pause();
    else play();
  });

  const play = () => {
    if (!video || userPaused || !inView) return;
    video.play().catch(() => {});
  };

  if (video && !reduceMotion.matches && !slowConnection()) {
    const src = isMobile.matches ? hero.dataset.srcMobile : hero.dataset.srcDesktop;
    if (src) {
      whenIdle(() => {
        video.src = src;
        video.addEventListener('playing', () => hero.classList.add('is-playing'), { once: true });
        play();
      });

      // Save battery: pause when scrolled away.
      new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting;
        if (inView) play();
        else video.pause();
      }).observe(hero);

    }
  }

  // Headlight: the pool of light follows the cursor. Desktop pointers only.
  if (hero.hasAttribute('data-headlight') && finePointer.matches && !reduceMotion.matches) {
    let frame = 0;
    let px = 0;
    let py = 0;
    hero.addEventListener('pointermove', (event) => {
      px = event.clientX;
      py = event.clientY;
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const rect = hero.getBoundingClientRect();
        hero.style.setProperty('--x', `${((px - rect.left) / rect.width) * 100}%`);
        hero.style.setProperty('--y', `${((py - rect.top) / rect.height) * 100}%`);
      });
    });
  }
}

document.querySelectorAll('[data-nr-hero]').forEach(initHero);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-nr-hero]').forEach(initHero);
});
